import { ProductUnit } from '../../../../types/ProductUnit';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { translate } from '../../../common/helpers/translate.helper';
import { ProductFormState } from '../components/ProductBaseForm';
import { ProductForm } from '../components/ProductForm';

import { useProductCreate } from './useProductCreate';

export const useCreateProductDrawer = () => {
    const { push, pop } = useDrawer();
    const { addToast, addErrorToast } = useToasts();
    const productCreateMutation = useProductCreate();

    return () => {
        const onSubmit = async (values: ProductFormState) => {
            try {
                await productCreateMutation.mutateAsync({
                    supplierProductGroup: values.supplierProductGroup,
                    name: values.name,
                    group: values.group,
                    packTypeDefault: values.packTypeDefault,
                    unitDefault: values.unitDefault as ProductUnit,
                });

                pop(drawerId);
                addToast(translate('productsOverview.createSuccessToast'));
            } catch {
                addErrorToast(translate('productsOverview.createErrorToast'));
            }
        };

        const drawerId = push({
            header: { title: translate('productsOverview.createDrawerTitle') },
            content: (
                <ProductForm
                    onSubmit={onSubmit}
                    initialState={{
                        supplierProductGroup: '',
                        name: '',
                        group: '',
                        packTypeDefault: '',
                        unitDefault: '',
                    }}
                />
            ),
        });
    };
};
